module.exports = __webpack_public_path__ + "static/media/wcg-symbol.c52c85fd.png";